const toggleButton = document.querySelector('.main-sel-lang');
const allCountryListEle = document.querySelector('.all-county-list');

// Toggle dropdown on button click
toggleButton.addEventListener('click', (event) => {
  event.stopPropagation(); // Prevent event from bubbling to document
  toggleButton.classList.toggle('open');

  if (toggleButton.classList.contains('open')) {
    openDomainDropdown();
  } else {
    closeDomainDropdown();
  }
});

// Close dropdown when clicking outside
document.addEventListener('click', () => {
  if (toggleButton.classList.contains('open')) {
    closeDomainDropdown();
    toggleButton.classList.remove('open');
  }
});

function openDomainDropdown() {
  allCountryListEle.style.visibility = 'visible';
  allCountryListEle.classList.add('open');
}

function closeDomainDropdown() {
  allCountryListEle.classList.remove('open');
  setTimeout(() => {
    if (!allCountryListEle.classList.contains('open')) {
      allCountryListEle.style.visibility = 'hidden';
    }
  }, 300);
}